import { UIHeading5, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './commentShow.css';
import { DeleteCommentButtonContainer } from '../../containers/DeleteCommentButtonContainer';
import { EditCommentButtonContainer } from '../../containers/EditCommentButtonContainer';

export interface ICommentShowProps {
  comment: string;
  entityId: number;
}

export const CommentShow = ({ comment, entityId }: ICommentShowProps) => {
  return (
    <div className={styles['container']}>
      <div className={styles['comment_content']}>
        <div>
          <UIHeading5>Ваша заметка:</UIHeading5>
          <UIText2>{comment}</UIText2>
        </div>
      </div>
      <div className={styles.comment_controls}>
        <EditCommentButtonContainer entityId={entityId} />
        <DeleteCommentButtonContainer entityId={entityId} />
      </div>
    </div>
  );
};
